'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _debounce = require('hs-lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _notifyBySound = require('conversations-internal-components/notifications/notifyBySound');

var _sendBrowserNotification = require('conversations-internal-components/notifications/sendBrowserNotification');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _Visitor = require('conversations-schema/records/Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _getAgentId = require('conversations-schema/pubnub-message/operators/getAgentId');

var _getResponders = require('../responders/selectors/getResponders');

var _getPreviewText = require('conversations-schema/operators/conversation/getPreviewText');

var _getPreviewText2 = _interopRequireDefault(_getPreviewText);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOTIFICATION_DEBOUNCE_MS = 2000;

var VisitorNotificationMiddleware = function VisitorNotificationMiddleware(store) {
  var playNotifications = (0, _debounce2.default)(function () {
    (0, _notifyBySound.notifyBySound)(false);
  }, NOTIFICATION_DEBOUNCE_MS, { leading: true, trailing: false, maxWait: NOTIFICATION_DEBOUNCE_MS });

  function isRecipientMessage(message) {
    var from = (0, _commonMessageFormatGetters.getSenderType)(message);
    return from === _senderTypes.AGENT || from === _senderTypes.BOT;
  }

  function getVisitor(channel) {
    var _store$getState = store.getState(),
        conversations = _store$getState.conversations;

    return (0, _getIn2.default)(['conversationsMap', channel, 'visitor'], conversations) || (0, _Visitor2.default)();
  }

  function getResponder(agentId) {
    var responders = (0, _getResponders.getResponders)(store.getState());
    return responders.getIn(['AGENT', agentId]);
  }

  return function (next) {
    return function (action) {
      switch (action.type) {
        case ActionTypes.RECEIVED_INCOMING_MESSAGE:
          {
            var _action$payload = action.payload,
                message = _action$payload.message,
                channel = _action$payload.channel,
                shouldNotify = _action$payload.shouldNotify;

            if (shouldNotify && isRecipientMessage(message) && (0, _messageTypeComparators.isChatMessage)(message)) {
              playNotifications({
                channel: channel,
                user: getVisitor(channel),
                text: (0, _pubnubMessageGetters.getText)(message),
                notificationFunction: _sendBrowserNotification.sendNewMessageNotification
              });
            }
            break;
          }

        case ActionTypes.SET_THREAD_ASSIGNEE:
          {
            var _action$payload2 = action.payload,
                _message = _action$payload2.message,
                conversation = _action$payload2.conversation,
                userId = _action$payload2.userId;

            var senderId = (0, _commonMessageFormatGetters.getSenderId)(_message);
            if ((0, _getAgentId.getAgentId)(_message) === userId && senderId !== userId) {
              playNotifications({
                channel: conversation.channel,
                user: getResponder(senderId),
                text: (0, _getPreviewText2.default)(conversation),
                notificationFunction: _sendBrowserNotification.sendAssignmentNotification
              });
            }
            break;
          }

        case ActionTypes.OPEN_CONVERSATION_FOR_NEW_CHANNEL:
          {
            var _action$payload3 = action.payload,
                _conversation = _action$payload3.conversation,
                shouldNotifyBySound = _action$payload3.shouldNotifyBySound;

            var _channel = (0, _threadGetters.getChannel)(_conversation);
            var notification = (0, _threadGetters.getSource)(_conversation) ? _sendBrowserNotification.sendNewMessageNotification : _sendBrowserNotification.sendNewEmailNotification;
            if (shouldNotifyBySound) playNotifications({
              channel: _channel,
              user: getVisitor(_channel),
              notificationFunction: notification
            });
            break;
          }

        default:
          break;
      }

      return next(action);
    };
  };
};

exports.default = VisitorNotificationMiddleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/middleware/VisitorNotificationMiddleware.js
// module id = 825
// module chunks = 2 3